import { component_tool, framework_tool, utils_tool } from '@/tool';
import React from 'react';

import { WizTableForm } from '@/containers/common';

const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()
let { WizModal,WizButton,WizDataTable} = component_tool;
//配置项
let componentName = 'procinsRun';

const columns =  [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "流程实例ID",
      name: "id",
      dataIndex: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "任务名称",
      name: "name",
      dataIndex: "name",
      searchItem: {},
      tableItem: {
        width: 200,}
    },

    {
      title: "业务类型",
      name: "key",
      dataIndex: "key",
      dict: [
        { code: "ApplyCommon", codeName: "公共报名" },
        { code: "Process", codeName: "测试流程" },
        { code: "Leave", codeName: "请假" },
      ],
      searchItem: {
        type: "select"},
      tableItem: {
        width: 100,
        type: "select"}
    },
    {
      title: "申请人",
      name: "startUserName",
      dataIndex: "startUserName",
      tableItem: {
        width: 100,}
    },
    {
      title: "申请人任职",
      name: "userIdentityInfo",
      dataIndex: "userIdentityInfo",
      tableItem: {
        width: 400,}
    },
    // {
    //   title: "标识Key",
    //   name: "key",
    //   dataIndex: "key",
    //   searchItem: {},
    //   tableItem: {}
    // },
    {
      title: "审核状态",
      name: "currentTask",
      dataIndex: "currentTask",
      tableItem: {
        width: 100,}
    },
    {
      title: "状态",
      name: "suspensionState",
      dataIndex: "suspensionState",
      tableItem: {
        width: 50,},
      dict: [
        { code: 1, codeName: "激活" },
        { code: 2, codeName: "挂起" }
      ],
    },
    {
      title: "组织机构",
      name: "organizationIdList",
      searchItem: {
        diy: WizTableForm,
        ...organizationConfig,
      }
    },
    {
      title: "岗位",
      name: "positionIdList",
      searchItem: {
        diy: WizTableForm,
        ...positionConfig,
      }
    },
    {
      title: "岗位分类",
      name: "positionCategoryId",
      searchItem: {
        ...positionCategoryConfig,
        selectType: 'radio',
        diy: WizTableForm,
        initialValue: undefined
      }
    },
  ];

const templateConfig = {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns:columns,
        searchBarProps: {
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort:[],
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false
        },
        rowOperateSort:['hang','reviewInfo'],
        rowOperateView: [
          {
            key: "hang",
            custom: true,
            params: { children: "挂起"},
            //需要根据接口数据变换按钮文字内容的传入方式
            textFormat: {
              recordKey: 'suspensionState',
              dirt: { 1: '挂起', 2: '激活' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateSuspensionState",
                apiParams: {}
              },
              formatParams: (rows, record, filters,callback) => {
                const content = `${record['suspensionState'] === 1 ? "您确定要挂起吗?" : "您确定要激活吗?"}`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      suspensionState: record['suspensionState'] === 1 ? 2 : 1,
                      id: record['id'],
                    })
                  },
                  onCancel() { }
                });
                return null
              }
            }
          },
          {
            key: "reviewInfo",
            custom: true,
            params: { children: "审核信息"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/workflow/managerAuditHistory",
                record: {"managerType":1}
              },
            },
          },
        ],

        commonOperate: {}
      }
    }
};

const apis = {
  list: {
    path: `${componentName}/runListByPage`,
    payload: {
      key: `${componentName}@runListByPage`,
    }
  },
  updateSuspensionState:{
    path: `${componentName}/updateSuspensionState`,
    payload: {
      key: `${componentName}@updateSuspensionState`,
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig }
